export enum RiskMode {
  'CrossAsset' = 'CrossAsset',
  'SingleAsset' = 'SingleAsset', // 暂时未使用
  'Isolated' = 'Isolated',
  'Classic' = 'Classic',
  'MultiAsset' = 'MultiAsset',
}

export enum ContractAccountMarginMode {
  Single = 'SINGLE_ASSET',
  Multi = 'MULTI_ASSETS',
}
